<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/135QRID/tc-custom/9780226074641.jpg?1736394678560" alt="This image is the cover for the book Wildlife Conservation in a Changing Climate"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wildlife Conservation in a Changing Climate
      </h1>
      <p class="bookDescription body article font2">
        <p>Human-induced climate change is emerging as one of the gravest threats to biodiversity in history, and while a vast amount of literature on the ecological impact of climate change exists, very little has been dedicated to the management of wildlife populations and communities in the wake of unprecedented habitat changes. <i>Wildlife Conservation in a Changing Climate</i> is an essential resource, bringing together leaders in the fields of climate change ecology, wildlife population dynamics, and environmental policy to examine the impacts of climate change on populations of terrestrial vertebrates. Chapters assess the details of climate change ecology, including demographic implications for individual populations, evolutionary responses, impacts on movement patterns, alterations of species interactions, and predicting impacts across regions. The contributors also present a number of strategies by which conservationists and wildlife managers can counter or mitigate the impacts of climate change as well as increase the resilience of wildlife populations to such changes. A seminal contribution to the fields of ecology and conservation biology, <i>Wildlife Conservation in a Changing Climate</i> will serve as the spark that ignites a new direction of discussions about and action on the ecology and conservation of wildlife in a changing climate.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jedediah F. Brodie, Eric S. Post, Daniel F. Doak
      </h2>
      
      <p class="authorDescription body article"><P><B>Jedediah F. Brodie</B> is assistant professor of conservation ecology at the University of British Columbia. <B>Eric S. Post</B> is professor of biology at the Pennsylvania State University. <B>Daniel F. Doak</B> is professor in the Department of Zoology and Physiology at the University of Wyoming.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?20a61842